export const SEO_META = {
  // Landing / Home
  '/': {
    title: 'JuristBot AI | Legal AI Chatbot for Research & Drafting',
    description:
      'JuristBot is a Legal AI assistant for Indian lawyers and law firms, offering AI-powered legal research, drafting, case analysis, judgment search and more.',
  },

  // ── Feature pages ──

  // AI Legal Research
  '/ai-legal-research-software-chatbot-assistant-juristbot-ai': {
    title: 'AI Legal Research Software Chatbot Assistant | JuristBot',
    description:
      'Research Indian laws, case law and judgments faster with JuristBot AI, an AI legal research software assistant built for lawyers, advocates and legal professionals.',
  },

  // AI Legal Drafting
  '/ai-legal-drafting-software-chatbot-juristbot-ai': {
    title: 'AI Legal Drafting Software for Indian Lawyers | JuristBot',
    description:
      'Draft legal documents faster with JuristBot AI. Create petitions, affidavits, notices and other legal documents with AI built for Indian legal professionals.',
  },

  // Judgment Finder
  '/ai-legal-judgment-finder-for-indian-case-law-juristbot-ai': {
    title: 'Judgment Finder & Case Law Search for Indian Lawyers | JuristBot',
    description:
      'Find Indian judgments and case law faster with AI Legal Chatbot assistant - JuristBot AI. Search Supreme Court and High Court judgments for efficient legal research.',
  },

  // Scenario Solver
  '/ai-legal-scenario-solver-and-legal-case-analysis-juristbot-ai': {
    title: 'AI Legal Case Analysis & Scenario Solver for Lawyers | JuristBot',
    description:
      'Analyze legal scenarios and complex cases with AI legal Assistant - JuristBot AI. Explore Indian laws, sections and case issues to support legal case preparation.',
  },

  // AI Cross Examination
  '/ai-legal-cross-examination-chabot-juristbot-ai': {
    title: 'AI Cross Examination for Lawyers | JuristBot',
    description:
      'Prepare cross-examination questions faster with AI legal Chatbot JuristBot AI. Analyze case details and create relevant questions for effective legal preparation.',
  },

  // ── Other pages ──

  // Pricing page
  '/#pricing': {
    title: 'AI Legal Drafting Plans & Pricing | Juristbot AI',
    description:
      "Explore Juristbot AI's affordable plans for AI legal drafting, case law research, and patent drafting. Best AI tool for lawyers in India.",
    keywords:
      'ai legal drafting, best ai tools in india, legal drafting ai, best legal ai tools in india, ai for lawyers india',
  },

  // Course page
  '/course': {
    title: 'Learn AI Legal Research & Drafting | Juristbot AI',
    description:
      'Master AI-assisted legal drafting and research with Juristbot AI courses. Designed for Indian lawyers, advocates, and legal professionals.',
    keywords:
      'ai tool for legal research, ai assisted patent drafting, legal research ai india, ai for lawyers india, advocate drafting software',
  },

  // Login page
  '/login': {
    title: 'Login to Juristbot AI | AI LegalGPT Platform',
    description:
      "Sign in to Juristbot AI and access India's leading AI LegalGPT for legal drafting, case law research, and AI-powered legal tools.",
    keywords: 'AI LegalGPT, Juristbot AI LegalGPT, legal ai tools, indian legal ai tool',
  },

  // Terms page
  '/Terms': {
    title: 'Terms of Service | Juristbot AI Legal Platform',
    description:
      "Read Juristbot AI's terms of service. Understand how India's AI LegalGPT platform handles legal drafting, research tools, and user data.",
    keywords: 'AI LegalGPT, legal document drafting ai, indian legal ai tool, legal ai tool',
  },

  // Register page
  '/register': {
    title: 'Register Free on Juristbot AI | AI Legal Tool',
    description:
      'Create your free Juristbot AI account. Get instant access to AI legal drafting, case law research AI, and the best legal AI tools in India.',
    keywords:
      'ai legal drafting, case law research ai, best legal ai tools in india, ai for lawyers india, legal ai for drafting',
  },

  // Lawyer directory / listing
  '/list-lawyers': {
    title: 'Find Lawyers in India | Juristbot AI Directory',
    description:
      'Browse verified lawyers and advocates across India on Juristbot AI. Find legal experts who use AI tools for drafting and case research.',
    keywords:
      'advocate drafting software, ai for lawyers india, legal ai tools, legal research ai india, best ai tools in india',
  },

  // Privacy policy
  '/Privacy_Policy': {
    title: 'Privacy Policy | Juristbot AI',
    description:
      "Read Juristbot AI's privacy policy. Learn how India's AI LegalGPT platform collects, uses, and protects your data.",
    keywords: 'juristbot ai privacy, AI LegalGPT, legal ai tool india',
  },

  // Help & FAQ
  '/help&FAQ': {
    title: 'Help & FAQ | Juristbot AI',
    description:
      'Get answers to common questions about Juristbot AI — AI legal drafting, tokens, subscriptions, and platform usage for Indian advocates.',
    keywords: 'juristbot help, ai legal drafting faq, legal ai tool india, juristbot tokens',
  },

  // Demo feature
  '/demo-feature': {
    title: 'Try Juristbot AI Demo | AI Legal Drafting Tool',
    description:
      'Experience Juristbot AI for free. Try AI-powered legal drafting, case law research, and cross-examination tools designed for Indian lawyers.',
    keywords: 'juristbot demo, ai legal drafting, free legal ai tool, ai for lawyers india',
  },
};

export const DEFAULT_SEO = {
  title: 'Juristbot AI | AI Legal Tool for Indian Lawyers',
  description:
    'Juristbot AI — AI-powered legal drafting, case law research, and cross-examination tools for Indian advocates and legal professionals.',
  keywords: 'ai legal drafting, legal research ai india, ai for lawyers india, juristbot ai',
};